module.exports = __webpack_public_path__ + "static/vehicles-2c3892bf02aa0c791fef6ab7f2240bf0.png";